// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604240908/js/" + chunkId + "." + {"44":"dd930be0","225":"d5670ce4","481":"316ba2ba","486":"3572d493","770":"e0413e37"}[chunkId] + ".0.38715907143694994.chunk.js";
};